module.exports = __webpack_public_path__ + "static/media/portfolioPic.8436197b.jpg";